angular.module('qkr').factory('feedbackService', ($http, appConfig) => ({
		saveFeedback(mssFeedback) {
			return $http.post(appConfig.apiUrl + 'mssFeedback/create', mssFeedback).
								then((response) => response.data);
		},
		
		load() {
			return $http.get(appConfig.apiUrl + 'mssFeedback/list').
							then((response) => response.data);
		},
		
		loadAll() {
			return $http.get(appConfig.apiUrl + 'mssFeedback/listAll').
							then((response) => response.data);
		}
	}));



// WEBPACK FOOTER //
// ./src/services/feedback.service.js